import style from './style';
import { stylingRoom } from './stylingRoom';
import stylists from './stylists';
import users from './users';

export default {
    users,
    style,
    stylists,
    stylingRoom
};

export * from './stylingRoom';
